module.exports = __webpack_public_path__ + "static/media/going2.704423ca.jp2";